
import { Module, ActionContext } from 'vuex'
import { RootState, CustomValuesState } from './state_models'
import { CustomValue } from '../models/api'

export const customValues: Module<CustomValuesState, RootState> = {
  namespaced: true,
  state: { customValues: [], locationId: undefined } as CustomValuesState,
  mutations: {
    setCustomValues (state, { customValues, locationId}) {
      state.customValues = [...customValues]
      state.locationId = locationId
    },
    clearAll(state) {
      state.customValues = [];      
      state.locationId = undefined
    }
  },
  actions: {
    async getByLocationId(
      context: ActionContext<CustomValuesState, RootState>,
      params: { locationId: string }
    ) {
      if(!params || !params.locationId) {
        return []
      }

      const locationId = params.locationId;

      if (context.state.locationId === locationId) {
        return context.state.customValues
      }

      const result = await CustomValue.list(locationId)
      if(result) {
        context.commit('setCustomValues', { customValues: result, locationId });
        return result
      } 

      return []
    },
    logout: {
      root: true,
      handler: async (context: ActionContext<CustomValuesState, RootState>) => {
        context.commit('clearAll')
      }
    },
    clearAll: {
      handler: async (context: ActionContext<CustomValuesState, RootState>) => {
        context.commit('clearAll')
      }
    }
  }
}
